
<style scoped>
.fbStyleButton {
  background-color: #4267b2;
  color: white;
  border-color: #4267b2;
  font-size: 12px;
}
</style>

<style>
.code-input input {
  text-align: center;
  font-weight: bold;
}
</style>

<template>
  <app-layout class="login-template">
    <AuthComponent v-show="true"/>
    <Row type="flex" justify="center" style="padding-top:5px" v-show="false">
      <i-col :xs="24" :sm="24" :md="24" :lg="24" v-if="authType == 'signin'">
        <div class="signin" style="padding:20px">
          <Row type="flex" :gutter="20">
            <i-col span="24" style="margin-bottom:10px; font-size: 3vh">
              <p align="center">Welcome</p>
              <!-- <RadioGroup
                v-model="loginMode">
                <Radio
                  label="mobile">
                  Mobile
                </Radio>
                <Radio
                  label="email">
                  Email
                </Radio>
                <Radio
                  :disabled="true"
                  label="anon">
                  Anonymous
                </Radio>
              </RadioGroup>-->
            </i-col>
            <i-col span="24" style="margin-bottom:10px">
              <Input
                v-if="loginMode == 'email'"
                size="large"
                v-model="signin.email"
                type="email"
                placeholder="Email"
                name="loginName"
              ></Input>
              <Input
                v-else-if="loginMode == 'anon'"
                size="large"
                v-model="signin.email"
                type="email"
                placeholder="Username"
                name="loginUsername"
              ></Input>
              <tel-input-lg v-else name="loginPhone" v-model="signin.email" ref="telInput"></tel-input-lg>
            </i-col>
            <i-col span="24">
              <div class="ivu-input-wrapper ivu-input-wrapper-large ivu-input-type">
                <input
                  spellcheck="false"
                  type="password"
                  v-model="signin.password"
                  v-on:keyup.enter="signOn(authType)"
                  placeholder="Password"
                  class="ivu-input ivu-input-large"
                />
              </div>
              <!-- <Input  size="large" v-model="signin.password" type="password" placeholder="Password"></Input> -->
            </i-col>
            <i-col span="24">
              <router-link tag="p" to="/forgot-password" style="padding: 10px 0 0;color:#aaa">
                <a>Forgot Password?</a>
              </router-link>
            </i-col>
          </Row>
          <!-- setMemberMethod('signin') -->
        </div>
      </i-col>
      <i-col
        :xs="24"
        :sm="20"
        :md="18"
        :lg="18"
        v-if="authType == 'signup' && !isLoggingIn && !isSuccessRegister"
      >
        <div class="signup" style="padding:15px 20px 10px">
          <Row type="flex" :gutter="20">
            <i-col :span="24" style="margin-bottom:10px" v-if="registerMethod == 'anonymous'">
              <Input v-model="register.username" placeholder="Username" name="registerUsername" />
            </i-col>
            <i-col
              :span="16"
              style="margin-bottom:10px"
              v-else-if="tempNumber && registerMethod == 'mobile'"
            >
              <!-- <tel-input-lg v-model="tempNumber" @onTelInput="onTelInput" ref="telInput"></tel-input-lg> -->
              <!-- <Input v-model="tempNumber" readonly placeholder="Mobile Number"/> -->
              <strong>Mobile : {{ tempNumber }}</strong>
              <span style="display:block">
                <Icon type="checkmark-circled" style="margin-left: 6px; color: green"></Icon>Verified
              </span>
            </i-col>
            <Col :span="8" v-if="registerMethod === 'mobile'">
              <span style="float:right;">
                <a style="font-size:16px" @click="changeNumber(true)">Change Number</a>
              </span>
            </Col>
            <i-col :span="24" v-if="registerMethod == 'mobile'">
              <span style="font-style: italic; font-size: .9em ">Display Name</span>
              <Input
                v-model="register.display_name"
                placeholder="Display Name"
                name="registerDisplayName1"
              />
            </i-col>
            <i-col :span="24" style="margin-bottom:10px" v-else>
              <span style="font-style: italic; font-size: .9em ">Display Name</span>
              <Input
                style="margin-bottom:10px"
                v-model="register.display_name"
                placeholder="Display Name"
                name="registerDisplayName"
              />
              <span style="font-style: italic; font-size: .9em ">Email</span>
              <Input
                v-model="register.email"
                type="email"
                placeholder="Email"
                name="registerEmail"
              />
            </i-col>
            <!-- <Col v-show="signinMobile" span="24" style="margin-bottom:10px">
            <tel-input-lg v-model="mobile" @onTelInput="onTelInput" ref="telInput"></tel-input-lg></Col>-->
            <!-- <i-col span="24" style="margin-bottom:10px" v-if="!tempNumber">
            <i class="fa fa-info-circle" /> Register as anonymous? <i-switch v-model="isAnonymous" size="small" /></i-col>-->
            <!-- <Col v-show="!tempNumber && isAnonymous" span="24" style="margin-bottom:10px">
              <Input v-model="register.username" type="email" placeholder="Username" /></Col>
            <Col v-show="!tempNumber && !isAnonymous" span="24" style="margin-bottom:10px">
            <Input v-model="register.email" type="email" placeholder="Email" /></Col>-->
            <i-col span="24" style="margin-bottom:10px" v-if="tempNumber && verified">
              <!-- <p style="font-size:18px" align="center">Let's get started</p> -->
              <p v-if="false">
                <span style="float:right">
                  <a @click="changeNumber()">Change Number</a>
                </span>
                <b>
                  {{register.contact_number}}
                  <span style="color:green">
                    <Icon type="checkmark-circled"></Icon>Confirmed
                  </span>
                </b>
              </p>
            </i-col>
            <!-- <i-col span="12" style="margin-bottom:10px" v-show="registerMethod !== 'anonymous'">
              <Input v-model="register.first_name" placeholder="First Name" /></i-col>
            <i-col span="12" style="margin-bottom:10px" v-show="registerMethod !== 'anonymous'">
            <Input v-model="register.last_name" placeholder="Last Name" /></i-col>-->
            <!-- <Input size="large" v-model="register.contact_number" type="number" placeholder="Mobile"></Input></Col> -->
            <span
              style="font-style: italic; font-size: .9em; margin-left: 8px;"
            >*Password must be 8 characters or more</span>
            <i-col span="24" style="margin-bottom:10px">
              <Input
                v-model="register.password"
                type="password"
                placeholder="Password"
                name="registerPassword"
              />
            </i-col>
            <i-col span="24">
              <Input
                v-model="confirmPassword"
                type="password"
                placeholder="Confirm Password"
                name="registerConfirmPassword"
              />
            </i-col>
          </Row>
        </div>
      </i-col>
      <i-col :xs="24" :sm="20" :md="18" :lg="18" v-if="authType">
        <div class="signup" style="padding:10px 20px 10px">
          <div v-if="!isStep">
            <Button
              type="primary"
              long
              @click="signOn(authType)"
              :loading="isLoggingIn"
              v-show="!isSuccessRegister"
            >{{(authType === 'signup') ? 'Register': 'Login'}}</Button>
          </div>
          <div v-else style="margin-top: 10px">
            <Button
              type="primary"
              style="float:right"
              @click="signOn(authType)"
              :loading="isLoggingIn"
            >{{(authType === 'signup') ? 'Submit': 'Login'}}</Button>
            <Button
              @click="goBack()"
              type="text"
              class="btn-text"
              style="float:right;margin-right:10px;padding:6px 15px;color:#495060"
            >Go Back</Button>
          </div>
        </div>
      </i-col>
      <Col :xs="24" :sm="20" :md="18" :lg="16" v-show="!isLoggingIn && !isSuccessRegister">
        <p align="center" style="padding:10px 0 5px">
          {{(authType === 'signup') ? "Already" : "Don't"}} have an account?
          <a
            v-if="authType === 'signup'"
            @click="setMemberMethod('signin')"
          >Login</a>
          <a v-else @click="toSignUp()">Register</a>
        </p>
        <p align="center">
          Continue as
          <router-link :to="'/'+$route.params.brandSlug+'/'">Guest</router-link>
        </p>
      </Col>
      <i-col :xs="24" :sm="20" :md="18" :lg="16" v-show="!isLoggingIn">
        <div class="signup" style="padding:0 20px 20px">
          <Row :gutter="20" v-if="!authType" style="margin-top:20px">
            <i-col span="24">
              <Button
                long
                shape="circle"
                type="default"
                size="large"
                :loading="$store.state.base.isAuthenticating"
                disable="$store.state.base.isAuthenticating"
                style="margin-bottom:10px"
                @click="setMemberMethod('signin')"
              >LOGIN</Button>
            </i-col>
            <i-col span="24" v-show="!isSuccessRegister">
              <Button
                long
                shape="circle"
                type="default"
                size="large"
                :loading="$store.state.base.isAuthenticating"
                disable="$store.state.base.isAuthenticating"
                style="margin-bottom:10px"
                @click="toSignUp()"
              >REGISTER</Button>
            </i-col>
          </Row>
          <a
            v-if="false"
            class="fbStyleButton ivu-btn ivu-btn-long ivu-btn-circle ivu-btn-large"
            :href="fbLoginUrl"
          >
            <Icon
              type="social-facebook"
              style="background:#4267b2;padding:2px 3px 0 5px;color:#fff;font-size:15px;border-radius:2px;"
            ></Icon>
            <span style="vertical-align:top;line-height:20px">SIGN WITH FACEBOOK</span>
          </a>
        </div>
      </i-col>
      <i-col v-if="brandInfo.enable_saml == 1 && brandInfo.saml" :xs="24" :sm="20" :md="18" :lg="16">
        <div class="signup" style="padding:0 20px 20px">
          <Row :gutter="20" style="border-top: 1px solid #e8eaec; padding-top:20px">
            <i-col span="24">
              <Button type="primary" @click="redirectSSO" long>Login with {{brandInfo.saml.name}}</Button>
            </i-col>
          </Row>
        </div>
      </i-col>
    </Row>
  </app-layout>
</template>

<script>
import AuthComponent from '@/components/auth/Authentication'
import _ from "lodash";
import Utils from "@/utils.js";
import VueCookie from "vue-cookie";
import { TelInputLg } from "@/helpers/tel-input";
import store from "@/store";
import { mapGetters } from "vuex";
import Axios from "axios";

export default {
  name: "LoginComponent",
  
  data() {
    return {
      loginMode: "mobile",
      code: null,
      isSuccessRegister: false,
      fbLoginUrl: null,
      authType: null,
      isAnonymous: false,
      registerMethod: "email",
      mobile: null,
      showWarningAlert: false,
      register: _.cloneDeep(Cons[0].REGISTER),
      confirmPassword: null,
      signin: Cons[0].SIGNIN,
      signinMobile: true,
      isLoggingIn: false,
      dialog: null,
      auth: null
    };
  },
  created() {
    // if ( VueCookie.get(Cons[0].PATHS.NAME + Cons[0].PATHS.BRAND + 'COOKIE') ) {
    //   this.$router.replace("/")
    // }
    this.$store.dispatch("base/getFacebookLink").then(res => {
      this.fbLoginUrl = res;
    });
  },
  mounted() {
    setTimeout(() => {
      // we have to set it on delay because of bad api request timing (race conditions)
      this.postMountedRoutines();
    }, 2000);
    this.authType =
      "type" in this.$route.query && this.$route.query.type
        ? this.$route.query.type
        : "signin";

    this.registerMethod =
      "method" in this.$route.query && this.$route.query.method
        ? this.$route.query.method
        : "email";
    // if( this.authType === 'signup' && !this.verified && !this.tempNumber)
    //   this.$router.replace('/step1')
    // else
    if (this.verified && this.tempNumber)
      this.register.contact_number = _.clone(this.tempNumber);

    this.getKeyVerification();

    if (this.authType == "signup") {
      setTimeout(() => {
        this.register.display_name = "";
        this.register.username = "";
        this.register.email = "";
        this.register.password = "";
        this.confirmPassword = "";
      }, 500);
    }

    window.addEventListener("message", this.returnSSO, false);
  },
  watch: {
    $route: function(n, o) {
      this.authType = "type" in n.query && n.query.type ? n.query.type : null;
      // if( this.authType === 'signup' && !this.verified && !this.tempNumber)
      //   this.$router.replace('/step1')
      // elsegobac
      if (this.verified && this.tempNumber)
        this.register.contact_number = _.clone(this.tempNumber);
    }
  },
  computed: {
    ...mapGetters("user", ["brandInfo"]),
    redirectLink() {
      return _.get(this.$route, "query.redirect")
    },
    token() {
      return _.get(this.$route, "query.token")
    },
    isStep() {
      return this.$route.query.step;
    },
    tempNumber: {
      get() {
        return this.$store.state.base.VCodeMobile;
      }
    },
    verified: {
      get() {
        return this.$store.state.base.VCodeVerified;
      }
    },
    isSigning: {
      get() {
        return this.$store.state.base.isAuthenticating;
      }
    }
  },
  components: {
    TelInputLg,
    AuthComponent
  },
  methods: {
    postMountedRoutines() {
      if (this.token) {
        let authCookie = {
          access_token: this.token
        }
        VueCookie.delete(Cons[0].PATHS.NAME + this.$route.params.brandSlug + '_COOKIE')
        VueCookie.set(
          Cons[0].PATHS.NAME + this.$route.params.brandSlug + "_COOKIE",
          JSON.stringify(authCookie)
        );
        Axios.defaults.headers.common['Authorization']  = 'Bearer ' + this.token
        
        this.$store.commit("base/setLoadingPage", true, { root: 1 });
        this.$store.dispatch('user/getUserInfo', null, {root:1})
          .then( res => {
            if (this.redirectLink) window.location.replace(this.redirectLink)
          })
      }
    },
    redirectSSO() {
      this.dialog = window.open(
        this.brandInfo.saml.login_url,
        '_blank',
        'width=340,height=600'
      );
    },
    returnSSO(e) {
      if (e && this.dialog !== null) {
        localStorage.removeItem(Cons[0].PATHS.NAME + Cons[0].PATHS.BRAND + "COOKIE");
        // clean up temp
        VueCookie.delete(
          `${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}VISITED_COURSE`
        );
        VueCookie.delete(
          `${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}VISITED_ARTICLE`
        );

        var date = new Date(e.data.token.expires_at);
        var seconds = date.getTime() / 1000; //1440516958

        var ndata = {
          token_type: "Bearer",
          expires_in: seconds,
          access_token: e.data.accessToken
        }

        localStorage.setItem(
          Cons[0].PATHS.NAME + Cons[0].PATHS.BRAND + "COOKIE",
          JSON.stringify(ndata)
        );

        Axios.defaults.headers.common["Authorization"] = null;
        Axios.defaults.headers.common["Authorization"] =
          "Bearer " + e.data.accessToken;
        this.$store.dispatch("user/getUserInfo", null, { root: 1 });
        this.dialog.close();
        setTimeout(() => {
          this.$router.replace({ path: '/home' });
        }, 2000);
      }
    },
    goBack() {
      this.register = _.cloneDeep(Cons[0].REGISTER);
      window.history.back();
    },
    onTelInput(res) {
      console.log(res);
      this.mobile = res.isValid ? res.number : null;
    },
    getKeyVerification() {
      if (this.$route.query.hasOwnProperty("key")) {
        this.$Spin.show();
        this.$store
          .dispatch("user/getRegistrationKey", { key: this.$route.query.key })
          .then(res => {
            console.log(this.register, res);
            this.register.email = res.user_email;
            setTimeout(() => {
              this.$Spin.hide();
            }, 1000);
          })
          .catch(err => {
            this.$Spin.hide();
          });
      }
    },
    changeNumber(isReplace) {
      this.$vlf
        .createInstance({
          storeName: "humanity"
        })
        .then(v => {
          v.removeItem("code");
          v.removeItem("mobile");
          v.removeItem("isVerified");
          store.commit("base/setVCode", null);
          store.commit("base/setVCodeMobile", null);
          store.commit("base/setVCodeVerified", false);
          if (isReplace) this.$router.replace("/verify");
          else store.commit("base/redirectToVerify");
        });
    },
    toSignUp() {
      this.$router.replace({ path: "/step3" });
    },
    setMemberMethod(type) {
      let prescriptionCode =
        "code" in this.$route.query && this.$route.query.code
          ? this.$route.query.code
          : null;
      let prescription =
        "prescription" in this.$route.query && this.$route.query.prescription
          ? this.$route.query.prescription
          : null;
      let pType =
        "ptype" in this.$route.query && this.$route.query.ptype
          ? this.$route.query.ptype
          : null;

      if (pType && prescription && prescriptionCode && type) {
        this.$router.replace({
          path:
            "/login?ptype=" +
            pType +
            "&type=" +
            type +
            "&prescription=" +
            prescription +
            "&code=" +
            prescriptionCode
        });
      } else if (!pType && !prescription && !prescriptionCode && type) {
        this.$router.replace({ path: "/login?type=" + type });
      } else if (!type && pType && prescriptionCode && prescription) {
        this.$router.replace({
          path:
            "/login?prescription=" +
            prescription +
            "&code=" +
            prescriptionCode +
            "&ptype=" +
            pType
        });
      } else {
        this.$router.replace({ path: "/login" });
      }
    },
    signOn(v) {
      let pType =
        "ptype" in this.$route.query && this.$route.query.ptype
          ? this.$route.query.ptype
          : null;
      let prescriptionCode =
        "code" in this.$route.query && this.$route.query.code
          ? this.$route.query.code
          : null;
      let prescription =
        "prescription" in this.$route.query && this.$route.query.prescription
          ? this.$route.query.prescription
          : null;

      console.log(v);

      switch (v) {
        case "signup":
          // if ( this.registerMethod !== 'anonymous' ) {
          //   if (
          //     _.isEmpty(this.register.first_name) ||
          //     _.isEmpty(this.register.last_name)
          //   ) {
          //     this.$store.commit("showNotice", {
          //       type: "warning",
          //       title: "Missing",
          //       desc: "Missing first & Last Name."
          //     });
          //     return false;
          //   }
          // }

          // if ( _.isEmpty(this.register.email) || _.isEmpty(this.register.contact_number) ) {
          //   this.$store.commit("showNotice", {
          //     type: "warning",
          //     title: "Missing",
          //     desc: (!this.tempNumber) ? "Please Enter a valid email.":"Please Enter a valid number"
          //   });
          //   return false;
          // }

          if (_.isEmpty(this.register.password)) {
            this.$store.commit("showNotice", {
              type: "warning",
              title: "Warning",
              desc: "Please set a password."
            });
            return false;
          } else if (_.size(this.register.password) < 8) {
            this.$store.commit("showNotice", {
              type: "error",
              title: "Error",
              desc: "Password must atleast 8 characters in length."
            });
            return false;
          } else if (_.isEmpty(this.confirmPassword)) {
            this.$store.commit("showNotice", {
              type: "warning",
              title: "Warning",
              desc: "Please enter confirm password."
            });
            return false;
          }

          if (this.register.password !== this.confirmPassword) {
            this.$store.commit("showNotice", {
              type: "error",
              title: "Error",
              desc: "Passwords do not match."
            });
            return false;
          }

          if (this.registerMethod == "anonymous") {
            this.$set(this.register, "user_type", "anonymous");
          } else {
            this.$set(this.register, "username", Utils.uuidGenerator());
            this.$set(this.register, "user_type", "member");
          }

          // this.$set(
          //   this.register,
          //   "display_name",
          //   this.register.first_name + " " + this.register.last_name
          // );

          if (pType && pType == "brand" && prescriptionCode) {
            this.register.branding_doctor_id = prescriptionCode;
          } else if (pType && pType == "group" && prescription) {
            VueCookie.set(
              Cons[0].PATHS.NAME + "PLAN_PRESCRIPTION",
              JSON.stringify(prescription)
            );
          }

          if (this.registerMethod !== "anonymous") {
            delete this.register.username;
          } else {
            delete this.register.contact_number;
            delete this.register.email;
            this.register.first_name = "Anonymous";
            this.register.last_name = "Member";
            this.register.display_name =
              this.register.display_name || this.register.username;
          }

          let pCode = VueCookie.get("PRESCRIPTION_CODE");
          if (pCode) this.register.invite_code = pCode;

          if (this.$route.query.hasOwnProperty("key")) {
            // this.$Spin.show()
            this.isLoggingIn = true;

            this.register.key = this.$route.query.key;
            this.$store
              .dispatch("base/registerByKey", { data: this.register })
              .then((res, data) => {
                this.$vlf
                  .createInstance({
                    storeName: "humanity"
                  })
                  .then(
                    v => {
                      // this.$Spin.hide()
                      this.isLoggingIn = false;
                      v.removeItem("code");
                      v.removeItem("mobile");
                      v.removeItem("isVerified");
                      store.commit("base/setVCode", null);
                      store.commit("base/setVCodeMobile", null);
                      store.commit("base/setVCodeVerified", false);
                      VueCookie.delete("PRESCRIPTION_CODE");
                      VueCookie.delete("PRESCRIPTION_MOBILE");
                    },
                    error => {
                      this.$Spin.hide();
                      this.isLoggingIn = false;
                    }
                  );
              });
          } else {
            // this.$Spin.show()
            this.isSuccessRegister = false;
            this.isLoggingIn = true;
            this.$store.commit("base/setLoadingPage", true, { root: 1 });
            this.$store
              .dispatch("base/register", { data: this.register, reroute: true })
              .then((res, data) => {
                this.$vlf
                  .createInstance({
                    storeName: "humanity"
                  })
                  .then(
                    v => {
                      v.removeItem("code");
                      v.removeItem("mobile");
                      v.removeItem("isVerified");
                      store.commit("base/setVCode", null);
                      store.commit("base/setVCodeMobile", null);
                      store.commit("base/setVCodeVerified", false);
                      VueCookie.delete("PRESCRIPTION_CODE");
                      VueCookie.delete("PRESCRIPTION_MOBILE");
                      this.register = _.cloneDeep(Cons[0].REGISTER);
                      setTimeout(() => {
                        // this.$Spin.hide()
                        this.isLoggingIn = false;
                        this.$router.push(
                          `/${this.$route.params.brandSlug}/onboarding`
                        );
                        this.$store.commit("base/setLoadingPage", false, {
                          root: 1
                        });
                        this.isSuccessRegister = true;
                      }, 4000);
                    },
                    error => {
                      // this.$Spin.hide()
                      this.isSuccessRegister = false;
                      this.isLoggingIn = false;
                      this.$store.commit("base/setLoadingPage", false, {
                        root: 1
                      });
                    }
                  );
              });
          }
          break;
        default:
          if (_.isEmpty(this.signin.password) || _.isEmpty(this.signin.email)) {
            this.$store.commit("showNotice", {
              type: "warning",
              title: "Missing",
              desc: "Missing mobile & password."
            });
            return false;
          }

          if (pType && pType == "brand" && prescription) {
            VueCookie.set(
              Cons[0].PATHS.NAME + "PRESCRIPTION",
              JSON.stringify(prescription)
            );
          } else if (pType && pType == "group" && prescription) {
            VueCookie.set(
              Cons[0].PATHS.NAME + "PLAN_PRESCRIPTION",
              JSON.stringify(prescription)
            );
          }
          this.isLoggingIn = true;
          this.$store
            .dispatch("base/authenticate", { response: this.signin })
            .then(res => {
              this.$vlf
                .createInstance({
                  storeName: "systemAlert"
                })
                .then(v => {
                  v.setItem("shareableActivity", {});
                  v.setItem("showAlert", true);
                });
              this.isLoggingIn = false;
            })
            .catch(err => {
              this.isLoggingIn = false;
            });
          break;
      }
    }
  }
};
</script>
